export const DEFAULTS = {
  propertyPrice: 500_000,
  downPaymentPercent: 20,
  loanYears: 25,
  wiborRate: 5.85,
  bankMargin: 2.0,
  monthlyIncome: 10_000,
  monthlyOverpayment: 0,
  monthlyRent: 0,
  bankCommissionPercent: 1.5,
  propertyInsuranceYearly: 500,
  isSecondaryMarket: true,
} as const

export const LIMITS = {
  propertyPrice: { min: 100_000, max: 3_000_000, step: 10_000 },
  downPaymentPercent: { min: 10, max: 90, step: 1 },
  loanYears: { min: 5, max: 35, step: 1 },
  wiborRate: { min: 0, max: 15, step: 0.01 },
  bankMargin: { min: 0.5, max: 5, step: 0.1 },
  monthlyIncome: { min: 3_000, max: 100_000, step: 500 },
  monthlyOverpayment: { min: 0, max: 20_000, step: 500 },
  monthlyRent: { min: 0, max: 15_000, step: 100 },
  bankCommissionPercent: { min: 0, max: 10, step: 0.1 },
  propertyInsuranceYearly: { min: 0, max: 5_000, step: 50 },
} as const

export const CURRENCY = {
  locale: 'pl-PL',
  currency: 'PLN',
} as const

export function formatPLN(amount: number): string {
  return new Intl.NumberFormat(CURRENCY.locale, {
    style: 'currency',
    currency: CURRENCY.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)
}

export function formatPercent(value: number): string {
  return `${value.toFixed(2)}%`
}

/** Simplified Polish notary fee (taksa notarialna) based on property price */
export function estimateNotaryFee(propertyPrice: number): number {
  if (propertyPrice <= 3_000) return 100
  if (propertyPrice <= 10_000) return 100 + (propertyPrice - 3_000) * 0.03
  if (propertyPrice <= 30_000) return 310 + (propertyPrice - 10_000) * 0.02
  if (propertyPrice <= 60_000) return 710 + (propertyPrice - 30_000) * 0.01
  if (propertyPrice <= 1_000_000) return 1_010 + (propertyPrice - 60_000) * 0.004
  if (propertyPrice <= 2_000_000) return 4_770 + (propertyPrice - 1_000_000) * 0.002
  return 6_770 + (propertyPrice - 2_000_000) * 0.0025
}
